import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IContentLanguageLabelModel } from '@fi-app/shared/fi-content-language-shared/fi-content-language-shared';
import { FiDialogsContentBase } from '@fi-app/shared/fi-dialogs/fi-dialogs-content-base';
import { ObjectTypes } from '@fi-app/shared/types/object-type';
import { IMediaBankFileReference } from '@fi-app/shared/media-bank';

interface INameDescriptionEditorDialogData {
    names: IContentLanguageLabelModel[];
    descriptions: IContentLanguageLabelModel[];
    selectedLanguageId: number;
    isNameRequired: boolean;
    isDescriptionRequired: boolean;
    objectType: ObjectTypes;
    mediaBankFileReferences: IMediaBankFileReference[];
    showAttachmentsArea: boolean;
    nameFormFieldClassName: string;
    parentDialogClassName: string;
    namePlaceholderTextId: string;
    namePlaceholderHintTextId: string;
    descriptionPlaceholderTextId: string;
    descriptionPlaceholderHintTextId: string;
    isInsertLinkHidden?: boolean;
}

interface INameDescriptionEditorDialogResult {
    names: IContentLanguageLabelModel[];
    descriptions: IContentLanguageLabelModel[];
    mediaBankFileReferences: IMediaBankFileReference[];
}

@Component({
    selector: 'fi-name-description-editor-dialog',
    templateUrl: './name-description-editor-dialog.component.html',
    styleUrls: ['./name-description-editor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-name-description-editor-dialog' },
    standalone: false,
})
export class FiNameDescriptionEditorDialogComponent extends FiDialogsContentBase<
    INameDescriptionEditorDialogData,
    INameDescriptionEditorDialogResult
> {
    public isYesButtonDisabled(): boolean {
        return this.data.names.every((name) => !name.Value?.trim().length);
    }

    public getResult(): INameDescriptionEditorDialogResult {
        return {
            names: this.getTrimmedNames(this.data.names),
            descriptions: this.getTrimmedNames(this.data.descriptions),
            mediaBankFileReferences: this.data.mediaBankFileReferences,
        };
    }

    private getTrimmedNames(conentModels: IContentLanguageLabelModel[]): IContentLanguageLabelModel[] {
        return conentModels.map((contentModel) => {
            return {
                ...contentModel,
                Value: contentModel.Value?.trim() || '',
            };
        });
    }
}
